<template>
    <div class="basic_wrap">
        <!-- 顶部标题栏 -->
        <div class="withdraw_record_header">
            <div class="back_left" @click="$router.go(-1)">
                <img src="../../../src/assets/images/return.png" :alt="$t('invest.DepositRecords')">
            </div>
            <div class="big_tit">{{ $t('cash.WithdrawRecords') }}</div>
        </div>

        <!-- 主要内容区域 -->
        <div class="main_content">
            <!-- 表格头部 -->
            <div class="table_header">
                <div class="header_item">{{ $t('cash.Time') }}</div>
                <div class="header_item">{{ $t('cash.Status') }}</div>
                <div class="header_item">{{ $t('cash.Amount') }}</div>
                <div class="header_item">{{ $t('cash.Description') }}</div>
            </div>

            <!-- 记录列表区域 -->
            <div class="records_container">
                <!-- 加载状态 -->
                <div v-if="loading" class="loading_state">
                    <div class="loading_text">{{ $t('item.Loading') }}</div>
                </div>
                
                <!-- 空状态 -->
                <div v-else-if="withdrawRecords.length === 0" class="empty_state">
                    <div class="empty_text">{{ $t('invest.NoDepositRecord') }}</div>
                </div>
                
                <!-- 记录列表 -->
                <div v-else class="record_list">
                    <div 
                        v-for="record in withdrawRecords" 
                        :key="record.id" 
                        class="record_item"
                    >
                        <div class="record_time">{{ formatTime(record.time) }}</div>
                        <div class="record_type">{{ getWithdrawTypeText(record.status) }}</div>
                        <div class="record_amount">
                            <div class="amount_main amount_expense">
                                -{{ record.money }}
                            </div>
                            <div class="amount_before" v-if="record.money2">
                                <!-- {{ $t('cash.ActualAmount') }}: {{ record.money2 }} -->
                            </div>
                        </div>
                        <div class="record_desc">
                            <div class="desc_main">{{ getWithdrawDescText(record) }}</div>
                            <div class="desc_reason" v-if="record.charge && record.charge > 0">{{$t('item.shouxufei')}}}: ${{ record.charge }}</div>
                        </div>
                    </div>
                </div>
            </div>
		</div>

        <!-- 底部导航栏 -->
        <FooterTab :activeType="'user'" />
    </div>
</template>

<script>
import FooterTab from '../../components/FooterTab.vue'
import Fetch from '../../utils/fetch'

export default {
    name: "WithdrawRecord",
    components: { FooterTab },
    data() {
        return {
            show_icon_type: 'user',
            withdrawRecords: [], // 存储取款记录数据
            loading: false // 加载状态
        };
    },
    created() {
        this.$parent.footer("user", false);
        this.show_icon_type = 'user';
        this.getWithdrawRecords();
    },
    methods: {
        // 获取取款记录
        async getWithdrawRecords() {
            try {
                this.loading = true;
                console.log('开始获取取款记录...');
                
                // 调用API获取取款记录 - 使用cash_search获取专门的提现记录
                const result = await Fetch('/user/cash_search');
                
                console.log('取款记录API响应:', result);
                
                if (result && result.code === 1) {
                    console.log('提现记录获取成功:', result.data);
                    // cash_search 直接返回数组，不是包含list的对象
                    this.withdrawRecords = result.data || [];
                    
                    // 调试：打印第一条记录的结构
                    if (this.withdrawRecords.length > 0) {
                        console.log('第一条记录结构:', this.withdrawRecords[0]);
                    }
                } else if (result && result.code === 0) {
                    console.log('取款记录业务提示:', result);
                    // 显示业务提示信息
                    let message = '';
                    if (typeof result.info === 'string') {
                        message = result.info;
                    } else if (typeof result.info === 'object') {
                        const currentLang = localStorage.getItem('lang') || 'zh_hk';
                        message = result.info[currentLang] || result.info.zh_cn || '暂无记录';
                    }
                    console.log('提示信息:', message);
                    this.withdrawRecords = [];
                } else {
                    console.error('取款记录获取失败:', result);
                    this.withdrawRecords = [];
                }
            } catch (error) {
                console.error('获取取款记录出错:', error);
                this.withdrawRecords = [];
            } finally {
                this.loading = false;
            }
        },
        
        // 格式化时间
        formatTime(timeStr) {
            if (!timeStr || timeStr === '0000-00-00 00:00:00') {
                return '--';
            }
            return timeStr;
        },
        
        // 获取状态样式类
        getStatusClass(status) {
            switch (status) {
                case 0: return 'status_pending';
                case 1: return 'status_success';
                case 2: return 'status_failed';
                default: return 'status_unknown';
            }
        },
        
        // 获取状态文本
        getStatusText(status) {
            switch (status) {
                case 0: return this.$t('invest.Processing');
                case 1: return this.$t('invest.Success');
                case 2: return this.$t('invest.Failed');
                default: return this.$t('invest.Unknown');
            }
        },
        
        // 获取类型文本
        getTypeText(type) {
            switch (type) {
                case 1: return this.$t('invest.Income');
                case 2: return this.$t('invest.Expense');
                default: return this.$t('invest.Other');
            }
        },
        
        // 获取金额样式类
        getAmountClass(type) {
            switch (type) {
                case 1: return 'amount_income';
                case 2: return 'amount_expense';
                default: return 'amount_other';
            }
        },
        
        // 获取描述文本
        getDescText(record) {
            if (!record) return '--';
            
            // 尝试获取不同可能的描述字段
            const currentLang = localStorage.getItem('lang') || 'zh_hk';
            
            // 如果是多语言对象
            if (record.zh_cn) {
                return record.zh_cn;
            }
            
            // 如果是其他语言字段
            if (record[currentLang]) {
                return record[currentLang];
            }
            
            // 如果是直接的描述字段
            if (record.desc) {
                return record.desc;
            }
            
            if (record.description) {
                return record.description;
            }
            
            if (record.memo) {
                return record.memo;
            }
            
            // 如果没有找到任何描述字段，返回默认值
            return '--';
        },
        
        // 获取提现状态文本
        getWithdrawTypeText(status) {
            switch (status) {
                case 0: return this.$t('cash.Pending');
                case 1: return this.$t('cash.Success');
                case 2: return this.$t('cash.Failed');
                default: return this.$t('cash.Unknown');
            }
        },
        
        // 获取提现描述文本
        getWithdrawDescText(record) {
            if (!record) return '--';
            
            // 显示银行和账户信息
            let desc = '';
            if (record.bank && record.account) {
                // 对账号进行脱敏处理
                const maskedAccount = this.maskAccount(record.account);
                desc = `${record.bank} ${maskedAccount}`;
            } else if (record.account) {
                const maskedAccount = this.maskAccount(record.account);
                desc = maskedAccount;
            } else {
                desc = this.$t('item.tixianshenqing');
            }
            
            return desc;
        },
        
        // 账号脱敏处理
        maskAccount(account) {
            if (!account) return '********';
            
            const str = String(account);
            if (str.length <= 8) {
                return str.replace(/./g, '*');
            }
            
            // 保留前4位和后4位，中间用*代替
            const prefix = str.substring(0, 4);
            const suffix = str.substring(str.length - 4);
            const middle = '*'.repeat(Math.max(0, str.length - 8)); // 确保不会是负数
            
            return prefix + middle + suffix;
        }
    }
};
</script>

<style lang="less" scoped>
.basic_wrap {
    // min-height: 100vh;
    background: #ffffff;
    display: flex;
    flex-direction: column;
}

.withdraw_record_header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    color: #000000;
    border-bottom: 1px solid #f0f0f0;
    z-index: 1000;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .back_left {
        position: absolute;
        left: 15px;
        top: 0;
        bottom: 0;
        cursor: pointer;
        background: none;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 16px;
            height: 16px;
        }
    }

    .big_tit {
        font-size: 16px;
        font-weight: 500;
        color: #000000;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.main_content {
    flex: 1;
    background: #ffffff;
    padding-top: 54px; // 为固定头部留出空间
    padding-bottom: 20px; // 为底部导航栏留出空间
}

.table_header {
    display: flex;
    // background: #f8f9fa;
    // border-bottom: 1px solid #e9ecef;
    padding: 12px 0;

    .header_item {
        flex: 1;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        color: #495057;
        padding: 0 8px;
        
        &:first-child {
            flex: 1;
            text-align: center;
            padding-left: 16px;
        }
        
        &:nth-child(2) {
            flex: 1;
            text-align: center;
        }
        
        &:nth-child(3) {
            flex: 1.2;
            text-align: center;
            padding-right: 16px;
        }
        
        &:last-child {
            flex: 2;
            text-align: left;
            padding-left: 8px;
        }
    }
}

.records_container {
    flex: 1;
    min-height: 400px;
    background: #ffffff;
    
    .loading_state {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
        
        .loading_text {
            color: #666;
            font-size: 14px;
        }
    }
    
    .empty_state {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
        
        .empty_text {
            color: #999;
            font-size: 14px;
        }
    }
    
    .record_list {
        .record_item {
            display: flex;
            align-items: center;
            padding: 12px 16px;
            border-bottom: 1px solid #f0f0f0;
            
            &:last-child {
                border-bottom: none;
            }
            
            .record_time {
                flex: 1;
                font-size: 12px;
                color: #666;
                text-align: left;
                padding-left: 8px;
            }
            
            .record_type {
                flex: 1;
                font-size: 12px;
                color: #333;
                text-align: center;
            }
            
            .record_amount {
                flex: 1.2;
                text-align: right;
                padding-right: 8px;
                
                .amount_main {
                    font-size: 14px;
                    font-weight: 500;
                    display: block;
                    
                    &.amount_income {
                        color: #52c41a;
                    }
                    
                    &.amount_expense {
                        color: #ff4d4f;
                    }
                    
                    &.amount_other {
                        color: #333;
                    }
                }
                
                .amount_before {
                    font-size: 10px;
                    color: #999;
                    margin-top: 2px;
                    display: block;
                }
            }
            
            .record_desc {
                flex: 2;
                text-align: left;
                padding-left: 8px;
                
                .desc_main {
                    font-size: 12px;
                    color: #333;
                    line-height: 1.4;
                    word-break: break-all;
                }
                
                .desc_reason {
                    font-size: 10px;
                    color: #666;
                    margin-top: 2px;
                }
            }
        }
    }
}

/* 底部导航栏样式已移至FooterTab组件 */
</style>
